/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdsOption } from '@cds/ng-core/configuration';
import { CdsLangService, CdsLanguageModule } from '@cds/ng-core/lang';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { CdAutocompletePositionDirective } from './cd-autocomplete-position.directive';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-cd-autocomplete',
  templateUrl: './cd-autocomplete.component.html',
  styleUrls: ['./cd-autocomplete.component.scss'],
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    MatAutocompleteTrigger,
    CdAutocompletePositionDirective,
    ReactiveFormsModule,
    MatAutocomplete,
    MatOption,
    CdsIconModule,
    CdsLanguageModule,
  ],
})
export class CdAutocompleteComponent implements OnInit {
  private langService = inject(CdsLangService);

  @Input() placeholder?: string;
  @Input() label?: string;
  @Input() required = false;
  @Input() panelClass = '';
  @Input() flatPanel = false;

  @Input() control?: FormControl;
  @Output() valueChange = new EventEmitter();

  @Input()
  set options(options: CdsOption[]) {
    this.optionsSource = options.map(option => {
      option.label = this.langService.translate(option.label);
      return option;
    });
    this.optionsDisplayed = this._filter('');
  }

  // @ViewChild('inputBox') inputBox!: ElementRef<HTMLInputElement>;
  optionsSource: CdsOption[] = [];
  optionsDisplayed: CdsOption[] = [];
  autoCompleteControl = new FormControl<string | CdsOption>('', { nonNullable: true });
  optionSelected: CdsOption | '' = '';
  isFocus = false;

  onBlur() {
    this.isFocus = false;
    const value = this.autoCompleteControl.value;
    if (typeof value === 'string' && !this.optionsDisplayed.length) {
      this.autoCompleteControl.setValue(this.optionSelected, { emitEvent: false });
    }
  }

  onFocus() {
    this.isFocus = true;
    let value = this.autoCompleteControl.value;
    if (value && typeof value !== 'string') {
      value = value.label;
    }
    this.optionsDisplayed = value ? this._filter(value as string) : this.optionsSource.slice();
  }

  onClosed() {
    const value = this.autoCompleteControl.value;
    if (typeof value === 'string') {
      this.autoCompleteControl.setValue(this.optionSelected, { emitEvent: false });
    }
  }

  optionSelectedFn(ev: any) {
    this.optionSelected = ev.option.value;
    this.valueChange.emit(ev.option.value);
  }

  ngOnInit() {
    this.autoCompleteControl.valueChanges.subscribe(value => {
      let name = value;
      if (value && typeof value !== 'string') {
        if (this.control && this.control.value !== value.value) {
          this.control.setValue(value.value);
        }
        name = value.label;
      }
      if (this.isFocus) {
        this.optionsDisplayed = value ? this._filter(name as string) : this.optionsSource.slice();
      }
    });
    if (this.control) {
      this.control.valueChanges.subscribe(value => {
        const opt = this.optionsSource.find(option => option.value === value);
        if (opt) {
          const current = this.autoCompleteControl.value;
          const currentValue = typeof current === 'string' ? current : current?.value;
          if (currentValue !== opt.value) {
            this.autoCompleteControl.setValue(opt, { emitEvent: false });
          }
          this.optionSelected = opt;
        } else {
          if (this.autoCompleteControl.value !== '') {
            this.autoCompleteControl.setValue('', { emitEvent: false });
          }
          this.optionSelected = '';
        }
      });
      if (this.control.value) {
        const value = this.control.value;
        const opt = this.optionsSource.find(option => option.value === value);
        if (opt) {
          this.autoCompleteControl.setValue(opt, { emitEvent: false });
          this.optionSelected = opt;
        }
      }
    }
  }

  private _filter(name: string): CdsOption[] {
    const filterValue = name.toLowerCase();
    return this.optionsSource.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  displayFn(option: CdsOption) {
    return option ? option.label : '';
  }

  clearInput() {
    this.autoCompleteControl.patchValue('', { emitEvent: false });
    this.optionSelected = '';
    if (this.control) {
      this.control.setValue(this.control.defaultValue);
    }
    this.valueChange.emit('');
  }
}
